/* eslint-disable @typescript-eslint/no-unused-vars */
import { ButtonPrimeReact, DropdownPrimeReact } from "@finanedi.es/storybook"
import { useCuentasBancariasAll } from "api/CuentaBancaria.hook"
import { FORMA_PAGO } from "api/Types/FormaPago"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { FormasPago } from "features/Crear/pages/FormCreacionDocumento/hooks/ConvertirDocumento/ConvertirDocumento"
import { withFormik } from "formik"
import { useSelector } from "hooks/useSelector"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { globalSelector } from "routes/globalSlice"
import * as Yup from "yup"

const FormaPago = ({
  values,
  handleSubmit,
  onHide,
  isValid,
  setFieldValue,
}: {
  values: {
    formaPago: number | null
    formaPagoDescription: string | null
    formaPagoIban: string | null
    formaPagoIbanInput: string | undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    librado: $TSMigrationFixMe
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    librador: $TSMigrationFixMe
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit: $TSMigrationFixMe
  onHide: () => void
  isValid: boolean
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
}) => {
  const { t } = useTranslation()
  // TODO: GLOBALSELECTOR A RQ
  const { formasPago } = useSelector(globalSelector)

  const mappedFormasPago = useMemo(() => {
    return formasPago.map((f: FormasPago) => ({
      ...f,
      value: f.id,
    }))
  }, [formasPago])

  const { cuentaBancariaAll } = useCuentasBancariasAll({})

  const {
    activeCompany: { nif },
  } = useUsuarioEmpresaActiva()

  const mappedlistBankAccounts = useMemo(() => {
    return cuentaBancariaAll?.items?.map((f) => ({ ...f, value: f.id }))
  }, [cuentaBancariaAll?.items])
  const dropdownIbanList =
    values.formaPago === FORMA_PAGO.TRANSFERENCIA
      ? mappedlistBankAccounts?.filter(
          (account) => account.necesitaValidacion === false
        )
      : values?.librado?.cuentasBancarias

  const handleCuentaBancaria = async ({ value }: { value: string }) => {
    const matchAccount =
      values.formaPago === FORMA_PAGO.TRANSFERENCIA
        ? mappedlistBankAccounts?.find(
            (cuenta) =>
              cuenta?.cuentaContableEmpresaId === value || cuenta?.id === value
          )?.iban
        : values?.librado?.cuentasBancarias?.find(
            ({ id }: { id: string }) => id === value
          )?.iban
    setFieldValue("formaPagoIbanInput", value)
    setFieldValue("formaPagoIban", matchAccount)
  }

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='tw-mb-2'>
        <div className='tw-mb-4 tw-flex tw-flex-col'>
          <label htmlFor='formaPago'>
            {t("crear.facturaRec.modal.paymentFormLabel")}
          </label>
          <DropdownPrimeReact
            options={mappedFormasPago}
            value={values.formaPago}
            onChange={(e) => {
              const formaPagoDescription = formasPago?.find(
                (forma: FormasPago) => e.target.value === forma.id
              )?.description
              setFieldValue("formaPagoDescription", formaPagoDescription)
              setFieldValue("formaPago", e.target.value)

              const shouldResetIbanFields =
                e.target.value === FORMA_PAGO.TRANSFERENCIA ||
                e.target.value === FORMA_PAGO.PAGO_DOMICILIADO
              if (shouldResetIbanFields) {
                setFieldValue("formaPagoIbanInput", null)
                setFieldValue("formaPagoIban", null)
              }
            }}
            optionLabel='description'
            optionValue='value'
            placeholder={`${t(
              "crear.facturaRec.modal.placeholderPaymentForm"
            )}`}
            panelClassName='!tw-z-50'
          />
        </div>
        {(values.librador?.nif === nif || values.librador?.cif === nif) &&
          (values.formaPago === FORMA_PAGO.TRANSFERENCIA ||
            values.formaPago === FORMA_PAGO.PAGO_DOMICILIADO) && (
            <div className='tw-mb-4 tw-flex tw-flex-col'>
              <label htmlFor='formaPagoIbanInput'>
                {t("crear.facturaRec.modal.paymentFormBankAccountLabel")}
              </label>
              <DropdownPrimeReact
                options={[
                  {
                    iban: t(
                      "crear.facturaRec.modal.dropdownPaymentBankNotSelected"
                    ),
                    id: null,
                  },
                  ...(dropdownIbanList || []),
                ]}
                inputId='formaPagoIbanInput'
                value={values.formaPagoIbanInput}
                onChange={handleCuentaBancaria}
                optionValue='id'
                optionLabel='iban'
                className='!tw-w-full'
                placeholder={`${t(
                  "crear.facturaRec.modal.placeHolderPaymentFormBankAccount"
                )}`}
              />
            </div>
          )}
      </div>
      <div className='tw-mt-4 tw-flex tw-h-10 tw-flex-row tw-justify-end tw-items-center'>
        <ButtonPrimeReact
          className='tw-mr-3 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer hover:!tw-shadow'
          onClick={onHide}
        >
          {t("crear.facturaRec.modal.cancelButton")}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          type='submit'
          disabled={!isValid}
          className='!tw-bg-primary tw-h-10 tw-flex tw-justify-center tw-items-center hover:!tw-shadow hover:!tw-bg-primary-over'
        >
          {t("crear.facturaRec.modal.addButton")}
        </ButtonPrimeReact>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  formaPago: Yup.number().nullable(),
  formaPagoIban: Yup.string().nullable(),
  formaPagoIbanInput: Yup.string().nullable(),
})

const FormFormaPagoDocumento = withFormik({
  validationSchema: validate,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapPropsToValues: ({ data }: $TSMigrationFixMe) => ({
    formaPago: data.formaPago,
    formaPagoIban: data.formaPagoIban,
    formaPagoIbanInput: data.formaPagoIbanInput,
    formaPagoDescription: data.formaPagoDescription,
    librado: data.librado,
    librador: data.librador,
  }),
  validateOnMount: true,
  handleSubmit: (
    { formaPago, formaPagoIban, formaPagoIbanInput, formaPagoDescription },
    { props }
  ) => {
    props.onChange({
      formaPago,
      formaPagoDescription,
      formaPagoIban,
      formaPagoCuentaId: formaPagoIbanInput,
    })
    props.onHide()
  },
})(FormaPago)

export default FormFormaPagoDocumento
